<template>
  <div>
    <Subheader
      v-if="dynamicBattleModel.isBetweenClans"
      class="mx-2 text-truncate"
      :text="player.name || player.login"
    />
    <template v-for="item in squads">
      <Panel :key="item.name" class="mb-5 p-4">
        <div class="d-flex justify-content-between">
          <ListItemAccount
            class="w-75 mb-0"
            v-bind="{
              type: item.type,
              avatar: item.avatar || item.logo,
              name: $filters.displayName(item),
              accountId: item.login,
              approved: item.approved || item.validated,
              size: 35,
            }"
          >
          </ListItemAccount>
          <a
            v-if="item.login !== accountId"
            class="players-item-action h-ml-2 d-flex align-items-center"
            :href="`/conversations-redirect/${item.login}`"
            @click="openPopoverChat($event, item.login)"
          >
            <AppIcon name="msg" width="28" />
          </a>
          <a
            v-if="item.login !== accountId"
            class="players-item-action-sm h-ml-2 align-items-center"
            :href="`/conversations-redirect/${item.login}`"
          >
            <AppIcon name="msg" width="28" />
          </a>
        </div>
      </Panel>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import Panel from '@/components/atoms/Panel';
import ListItemAccount from '@/components/common/ListItemAccount';
import Subheader from '@/components/atoms/Subheader';
import AppIcon from '@/components/atoms/Icon';

export default {
  name: 'ParticipantRoster',
  components: {
    Panel,
    ListItemAccount,
    Subheader,
    AppIcon,
  },
  props: {
    player: {
      type: Object,
      required: true,
    },
    squads: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('my', ['accountId']),
    ...mapGetters(['dynamicBattleModel']),
  },
  methods: {
    ...mapMutations(['setActivePopoverChat', 'showPopoverChat']),
    ...mapActions(['getConversationInfo', 'errorNotify']),
    openPopoverChat(event, login) {
      if (!event.ctrlKey) {
        this.showPopoverChat();

        this.getConversationInfo({ conversationId: login })
          .then(res => {
            this.setActivePopoverChat(res.id);
          })
          .catch(this.errorNotify);
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
.players-item-action {
  display: block;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
  svg {
    path:first-child {
      fill: $ph-bg;
      stroke: $ph-secondary-text;
      stroke-opacity: 0.5;
      stroke-width: 2px;
    }
  }
}
.players-item-action-sm {
  display: none;
}
@media (max-width: 767px) {
  .players-item-action-sm {
    display: flex;
  }
  .players-item-action {
    display: none !important;
  }
}
</style>
